import useSocialAuthConf from "@casino/legacy/client/features/SocialAuth/hooks/useSocialAuthConf";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import { Loader } from "@workspace/frontend-ui";
import SocialAuthLoginView from "./SocialAuthLoginView";
import TelegramScript from "./Telegram/TelegramScript";

const SocialAuthLogin = () => {
  const { loading, error, connections } = useSocialAuthConf();
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Translate id="errors.general" />;
  }
  return (
    <>
      <TelegramScript />
      <SocialAuthLoginView connections={connections} />
    </>
  );
};

export default SocialAuthLogin;
